import React from 'react';
import Footer from '../Home/Footer/Footer';
import Navbar from '../Home/Navbar/Navbar';
import Started from '../Home/Started/Started';
import './Contact.css'

const Contact = () => {
    return (
        <div className="contact-root">
            <Navbar/>
            <Started className="mt-5"></Started>
            <Footer/>
        </div>
    );
};

export default Contact;